import React from 'react';
import PropTypes from 'prop-types';

const fields = {
  count: 'Antal trappsteg',
  straight_start: 'Antal raka steg nedtill',
  straight_end: 'Antal raka steg upptill',
  width: 'Trappans bredd mellan väggarna (mått i mm)',
};

const fieldKeys = Object.keys(fields);

class MeasurementsCurvedB extends React.Component {
  componentDidMount() {
    this.validate();
  }

  componentWillUnmount() {
    if (this.props.errors.steps) {
      this.props.setError('steps');
    }
  }

  validate() {
    const { steps = {} } = this.props.values;
    let error = '';

    fieldKeys.forEach((field) => {
      if (!error && (steps[field] === '' || (field.indexOf('straight_') === -1 && !steps[field]))) {
        error = 'required';
      }
    });

    this.props.setError('steps', error);
  }

  handleInputChange = (e) => {
    const { steps = {} } = this.props.values;

    const value = parseInt(e.target.value, 10);
    steps[e.target.name] = isNaN(value) ? '' : value;

    this.props.setValue('steps', steps);

    setTimeout(() => this.validate(), 50);
  };

  render() {
    const {
      instructions: {
        curved: instructions = {}
      }
    } = window.MTMReact;

    const {
      steps = {},
      stair_type,
    } = this.props.values;

    return (
      <React.Fragment>
        <div className="mtm-instructions" dangerouslySetInnerHTML={{ __html: instructions.steps[stair_type] }} />

        {fieldKeys.map((field) => (
          <label key={field}>
            {fields[field]}
            <input
              type="number"
              min={field.indexOf('straight_') === 0 ? 0 : 1}
              name={field}
              value={typeof steps[field] === 'undefined' ? '' : steps[field]}
              onChange={this.handleInputChange}
            />
          </label>
        ))}
      </React.Fragment>
    );
  }
}

MeasurementsCurvedB.propTypes = {
  values: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  setError: PropTypes.func.isRequired,
};

export default MeasurementsCurvedB;





// WEBPACK FOOTER //
// ./src/Step/steps/MeasurementsCurvedB.js